import {
	IAudienceSegmentType,
	IFilterType,
} from 'Components/flowChart/components/NodePreview/components/NodeFilter/types';

export const FILTER_TYPE_LABEL: Record<IFilterType, string> = {
	customer_attribute: 'Customers',
	user_attribute: 'Visitors',
	item_segment: 'Segments',
	event_attribute: 'Events',
};

export const CONDITION_TYPE_LABEL: Record<IAudienceSegmentType, string> = {
	customer_segment: 'Customers',
	user_segment: 'Visitors',
};
